import { isBrowser } from '../utils'

export class Interval {
  #intervalId: NodeJS.Timeout | undefined
  #enableRequestAnimationFrame: boolean | undefined

  constructor(callback: () => void, time: number) {
    if (isBrowser()) {
      this.#enableRequestAnimationFrame = true
      this.#startRequestAnimationFrame(callback, time)
    } else {
      this.#intervalId = setInterval(() => {
        callback()
      }, time)
    }
  }

  stop() {
    if (this.#intervalId) {
      clearInterval(this.#intervalId)
    } else {
      this.#enableRequestAnimationFrame = false
    }
  }

  #startRequestAnimationFrame(callback: () => void, time: number) {
    let previousTimeStamp: number | undefined

    const step = (timeStamp: number) => {
      if (previousTimeStamp === undefined) {
        previousTimeStamp = timeStamp
      }

      const elapsed = timeStamp - previousTimeStamp

      if (elapsed >= time) {
          callback()
          previousTimeStamp = timeStamp
          console.log('step', new Date())
      }

      if (this.#enableRequestAnimationFrame) {
        window.requestAnimationFrame(step)
      }

    }

    window.requestAnimationFrame(step)
  }
}
